import { render, staticRenderFns } from "./fix-and-unfix.vue?vue&type=template&id=d9b5197e&scoped=true&"
import script from "./fix-and-unfix.vue?vue&type=script&lang=js&"
export * from "./fix-and-unfix.vue?vue&type=script&lang=js&"
import style0 from "./fix-and-unfix.vue?vue&type=style&index=0&id=d9b5197e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b5197e",
  null
  
)

export default component.exports